<template>
  <tr>
    <td class="middle">{{ index + 1 }}.</td>

    <w-table-cell :model="item.subjectName">
      <w-textarea :model="item.subjectName" :disabled="disabled" />
    </w-table-cell>

    <w-table-cell :model="item.helpDate">
      <w-datepicker :model="item.helpDate" :disabled="disabled" />
    </w-table-cell>

    <w-table-cell :model="item.plnCost">
      <w-input class="money-input" :mask="moneyMask" :model="item.plnCostString" :disabled="disabled" />
    </w-table-cell>

    <w-table-cell :model="item.euroCost">
      <w-input class="money-input" :mask="moneyMask" :model="item.euroCostString" :disabled="disabled" />
    </w-table-cell>

    <w-row-buttons
      class="middle flex-nowrap"
      :model="item"
      :move-up="index != 0"
      :move-down="item.$parent.$value.length - 1 !== index"
      :delete-row="index != 0"
    />
  </tr>
</template>

<script>
import components from '@witkac/bootstrap4-components';

import { moneyMask } from '@/utils/moneyMask';

// @vuese
// @De Minimis Row
// @Group formStaticComponents
export default {
  components,
  props: {
    // Wartość przekazana do wypelnienia pola w schemacie
    item: { type: Object, required: true },

    // Indeks
    index: { type: Number, required: true },

    // Czy wyłączyć inputy
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      moneyMask
    };
  }
};
</script>

<style>
.money-input input {
  text-align: end;
}
</style>
